import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumKey'
})
export class EnumKeyPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: number, enumType: any): string {
    if (value === undefined || value === null || !enumType) {
      return `${value}`;
    }

    const index = Object.values(enumType).indexOf(value);

    if (!index) {
      return `${value}`;
    }

    return Object.keys(enumType)[index];
  }

}
